/**
 * mobile-nav.ts — chia menu chính (nav-config) cho thanh tab dưới của bản điện thoại (kiểu Lark Mobile):
 * vài mục dùng hằng ngày nằm thẳng trên thanh tab, phần còn lại gom vào hộp "Thêm". Hàm thuần — có test.
 */
import type { NavItem } from '@/components/shared/nav-config'

/** Mục nằm trên thanh tab (theo thứ tự hiển thị) — mục nào vai trò không có quyền thì tự vắng. */
export const MOBILE_TAB_KEYS = ['inbox', 'customers', 'reports'] as const

export function splitMobileNav(nav: NavItem[]): { tabs: NavItem[]; more: NavItem[] } {
  const tabs = MOBILE_TAB_KEYS.map((k) => nav.find((n) => n.key === k)).filter((n): n is NavItem => !!n)
  const more = nav.filter((n) => !tabs.includes(n))
  return { tabs, more }
}

/**
 * Trang TỰ quản lề + cuộn trên điện thoại (không bọc thêm lề 16px của khung ngoài): Nhắn tin (/conversations…) và Cài đặt cá nhân (/account…:
 * danh sách thẻ nhóm + chi tiết từng mục) — hai khối lề cộng dồn làm thẻ bị bó hẹp (~30px mỗi bên).
 */
export function isMobileFullBleedPath(pathname: string): boolean {
  return /^\/(conversations|account)(\/|$)/.test(pathname)
}

/** Màn chat toàn màn hình (/conversations/<id>): ẩn thanh tab dưới cho rộng chỗ, như Lark. */
export function isChatDetailPath(pathname: string): boolean {
  return /^\/conversations\/[^/]+/.test(pathname)
}
